import { EReputationMatchResult } from "src/core/types/entity";

type RelationsSectionProps = {
  selectedMatch: EReputationMatchResult;
};

export const RelationsSection = ({ selectedMatch }: RelationsSectionProps) => {
  if (!selectedMatch?.detail?.relations?.length) {
    return null;
  }

  return (
    <div className="flex flex-col mt-6 mx-10">
      <div className="space-y-3">
        {selectedMatch?.detail?.relations?.map((rel) => (
          <div
            key={rel.peid}
            className="flex flex-col bg-gray-xxlight rounded-md px-4 py-2 border border-border"
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                {rel?.watchlist?.length && rel?.watchlist?.length > 0 && (
                  <div className="flex flex-wrap gap-1">
                    {rel?.watchlist?.map((flag, idx) => (
                      <span
                        key={idx}
                        className="bg-red-badge text-white rounded-full px-2 py-0.5 border border-border"
                      >
                        {flag.type}
                      </span>
                    ))}
                  </div>
                )}
                <span className="font-light">{rel.name}</span>
              </div>
              <span className="font-light italic">{rel.relationship}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
